module.exports = __webpack_public_path__ + "img/DE01561.ebb3fdce.png";